import React, { useState, useContext, useEffect, useCallback } from 'react';
import { APIPutUserData, APIPutUserEmail } from '../../api/user/User';
import { UserContext } from '../../context/UserContext';
import {ProfileAttribute} from '../../components/profileAttribute';
import { AccessManagement } from '#src/components/accessManagement.js';

export const UserPage = () => {
    const {user} = useContext(UserContext);
    const [givenName, setGivenName] = useState('');
    const [familyName, setFamilyName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [addressStreet, setAddressStreet] = useState('');
    const [addressZipCode, setAddressZipCode] = useState('');
    const [addressCity, setAddressCity] = useState('');
    const [save, setSave] = useState(false);
    const [error, setError] = useState(null);

    const saveUser = useCallback(async () => {
        const userChangesDB = {
            id: user?.id,
            companyId: user?.companyId,
            name: `${givenName} ${familyName}`,
            role: user?.role,
            status: user?.status,
            details: {
                given_name: givenName,
                family_name: familyName,
                phone: phoneNumber,
                address: {
                    street: addressStreet,
                    zipCode: addressZipCode,
                    city: addressCity,
                    country: 'DE',
                },
            },
        };

        try {
            const trimmedEmail = email.trim();
            const userEmail = user?.email?.trim();
            if (userEmail !== trimmedEmail) {
                const emailChanged = await APIPutUserEmail(user.id, email, user.cognitoUser.username);
                if (emailChanged.error) {
                    setError(emailChanged.message);
                }
            } else {
                await APIPutUserData(userChangesDB);
            }
            // update user context
            user.details.given_name = givenName;
            user.details.family_name = familyName;
            user.details.phone = phoneNumber;
            user.details.address.street = addressStreet;
            user.details.address.zipCode = addressZipCode;
            user.details.address.city = addressCity;
            user.email = email;
            user.name = `${givenName} ${familyName}`;
            setError(null);
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    }, [addressCity, addressStreet, addressZipCode, email, familyName, givenName, phoneNumber, user]);

    useEffect(() => {
        if (user) {
            setGivenName(
                user?.details?.given_name
                    ? user?.details?.given_name
                    : user?.name?.split(' ')[0] || ''
            );
            setFamilyName(
                user?.details?.family_name
                    ? user?.details?.family_name
                    : user?.name?.split(' ')[1] || ''
            );
            setEmail(user?.email || '');
            setPhoneNumber(user?.details?.phone || '');
            setAddressStreet(user?.details?.address?.street || '');
            setAddressZipCode(
                user?.details?.address?.zipCode || ''
            );
            setAddressCity(user?.details?.address?.city || '');
        }
    }, [user]);

    useEffect(() => {
        if (save) {
            saveUser();
            setSave(false);
        }
    }, [save, saveUser]);

    return (
        <div className='mx-auto max-w-7xl bg-gray-100 lg:px-4'>
            <h2 className='text-xl truncate mb-4 ml-4 mt-8 mb-14 lg:text-2xl textShadow flex font-normal leading-7 text-gray-600 sm:truncate  sm:tracking-tight gap-2'>
                Benutzer
            </h2>
            <div className='grid grid-cols-1 xl:grid-cols-2 gap-8'>
                <div className='border border-gray-500 rounded-lg  w-full bg-white p-6'>
                    <div>
                        <h3 className='text-lg font-semibold text-lg text-gray-900'>
                            Details
                        </h3>
                    </div>

                    <div className={'mt-12'}>
                        {user && (
                            <div className='mt-6 '>
                                <dl className='px-4 sm:px-0'>
                                    <ProfileAttribute
                                        name={'Vorname'}
                                        type={'text'}
                                        value={givenName}
                                        setValue={setGivenName}
                                        setSave={setSave}
                                    />
                                    <ProfileAttribute
                                        name={'Nachname'}
                                        type={'text'}
                                        value={familyName}
                                        setValue={setFamilyName}
                                        setSave={setSave}
                                    />
                                    <ProfileAttribute
                                        name={'E-Mail'}
                                        type={'email'}
                                        value={email}
                                        setValue={setEmail}
                                        setSave={setSave}
                                    />
                                    <div className={`text-red text-sm ${error ? '-mt-[21px]' : 'hidden'}`}>
                                        {error}
                                    </div>
                                    <ProfileAttribute
                                        name={'Rufnummer'}
                                        type={'phone'}
                                        value={phoneNumber}
                                        setValue={setPhoneNumber}
                                        setSave={setSave}
                                    />
                                    <ProfileAttribute
                                        name={'Straße'}
                                        type={'text'}
                                        value={addressStreet}
                                        setValue={setAddressStreet}
                                        setSave={setSave}
                                    />
                                    <ProfileAttribute
                                        name={'PLZ'}
                                        type={'zipCode'}
                                        value={addressZipCode}
                                        setValue={setAddressZipCode}
                                        setSave={setSave}
                                    />
                                    <ProfileAttribute
                                        name={'Ort'}
                                        type={'text'}
                                        value={addressCity}
                                        setValue={setAddressCity}
                                        setSave={setSave}
                                    />
                                </dl>
                            </div>
                        )}
                    </div>
                </div>
                <div>
                    <AccessManagement />
                </div>
            </div>
        </div>
    );
}
